import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'

//components
import {SalesOfficeDropdownComponent} from '../../components/DomainData/SalesOfficeDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-driverdetails',
  templateUrl: './DriverDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => DriverDetailsComponent)}]
})
export class DriverDetailsComponent extends BaseControlGroupComponent {

    driverDetailsForm: FormGroup;

    public driverInfo: ent.DriverInfo = new ent.DriverInfo();

    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdownComponent: SalesOfficeDropdownComponent;

    @Input() public requireDriverName: boolean;
    @Input() public requireDriverPersonnelNumber: boolean;
    @Input() public requireSalesOffice: boolean;
    @Input() public requireSalesRoute: boolean;
  
    salesOfficeFilter: filters.SalesOfficeFilter;

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.driverInfo = request.DriverInfo;
        this.salesOfficeDropdownComponent.selectedID = this.driverInfo.CrossDockSalesOfficeID;
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        this.salesOfficeFilter = new filters.SalesOfficeFilter();
        this.salesOfficeFilter.SalesOfficeTypeID = enums.SalesOfficeType.CrossDock;
        
        let group = {
          'driverName' : '',
          'driverPersonnelNumber' : '',
          'salesOffice' : '',
          'salesRoute' : ''
        };
        
        this.driverDetailsForm = fb.group(group);

    }


    ngOnInit(): void {
        if(this.requireDriverName) {
            this.driverDetailsForm.controls['driverName'].setValidators(Validators.required);
        }
        if(this.requireDriverPersonnelNumber) {
            this.driverDetailsForm.controls['driverPersonnelNumber'].setValidators(Validators.required);
        }
        if(this.requireSalesOffice) {
            this.driverDetailsForm.controls['salesOffice'].setValidators(Validators.required);
        }
        if(this.requireSalesRoute) {
            this.driverDetailsForm.controls['salesRoute'].setValidators(Validators.required);
        }
        
    }

    crossDockSalesOfficeChange(event: any){
        this.driverInfo.CrossDockSalesOfficeID = event;
    }

}